<script lang="ts">
    import { fade } from "svelte/transition";
    import { contextMenuState } from "./ContextMenuStore";
    import MenuOption from "./MenuOption.svelte";

    // whenever x and y is changed, restrict box to be within bounds
    $: if (menuEl && $contextMenuState) {
        const rect = menuEl.getBoundingClientRect();
        let x = Math.min(window.innerWidth - rect.width, $contextMenuState.x);
        let y = $contextMenuState.y;
        if (y > window.innerHeight - rect.height) {
            y = $contextMenuState.y - rect.height;
        }
        $contextMenuState.x = x;
        $contextMenuState.y = y;
    }

    let menuEl: HTMLDivElement;

    function onPageClick(e: MouseEvent) {
        if (!menuEl || e.target === menuEl || menuEl.contains(e.target as Node)) return;
        //Kill the state.
        $contextMenuState = null;
    }
</script>

<svelte:body on:click={onPageClick} />
{#if $contextMenuState}
    <div
        transition:fade={{ duration: 100 }}
        bind:this={menuEl}
        style="top: {$contextMenuState.y}px; left: {$contextMenuState.x}px;"
        class="bg-white dark:bg-dark-400 border border-gray dark:border-dark-400 fixed z-[100] rounded-[5px] shadow-md grid gap-2 overflow-hidden"
    >
        {#each $contextMenuState.menuItems as item}
            <MenuOption
                isDisabled={item.disabled}
                on:click={() => {
                    item.callbackFunction();
                    $contextMenuState = null;
                }}
                contextMenuState={item}
            />
        {/each}
    </div>
{/if}
